<template>
  <div class="doc">
    <yu-head/>
    <div class="container">
      <yu-menu/>
      <yu-article>
        <div class="phone">
          <iframe src="http://mobileweb.yurencloud.com/#/popover" frameborder="0" width="320" height="580"></iframe>
        </div>


        <div class="title">气泡菜单</div>

        <div class="sub-title">普通用法</div>

        <pre v-highlightjs="code1"><code class="html" ></code></pre>
        <pre v-highlightjs="code2"><code class="javascript" ></code></pre>

        <div class="sub-title">属性</div>
        <yu-table :data="attributes1" :widths="widths1"/>

      </yu-article>
    </div>
  </div>
</template>

<script>
import { YuTable } from 'yu.ui';
import { YuButton, YuText } from 'yu.mobile';
import YuHead from './yu-head';
import YuMenu from './yu-menu';
import YuArticle from './yu-article';

export default {
  name: 'Buttons',
  data() {
    return {
      code1: `
 <yu-nav-bar title="气泡菜单" @clickMenu="showPopover"/>
 <yu-popover ref="popover">
      <li><i class="iconfont icon-camera"></i>相机</li>
      <li><i class="iconfont icon-qrcode"></i>二维码</li>
      <li><i class="iconfont icon-question"></i>帮助</li>
 </yu-popover>
      `,
      code2: `
import { YuNavBar, YuPopover } from 'yu.mobile';

export default {
  name: 'lists',
  methods: {
    showPopover() {
      this.$refs.popover.visible = true;
    },
  },
  components: {
    YuNavBar,
    YuPopover,
  },
};
      `,
      attributes1: [
        {
          prop: '参数',
          description: '说明',
          types: '类型',
          default: '默认值',
        },
        {
          prop: 'visible',
          description: '是否显示气泡菜单',
          types: 'Boolean',
          default: 'false',
        },
      ],
      widths1: {
        prop: '150px',
        description: '300px',
        types: '120px',
        default: '200px',
      },
    };
  },
  components: {
    YuHead,
    YuMenu,
    YuArticle,
    YuTable,
    YuButton,
    YuText,
  },
};
</script>

<style lang="scss" scoped type="text/scss">
  @import "../assets/css/varible";

  .doc {
    color: $text;
    height: 100%;
    .container {
      width: 1200px;
      margin: 30px auto;
      .title {
        color: $text;
        font-weight: bold;
        padding: 14px 0;
        margin: 20px 0;
        border-bottom: 1px solid $border;
      }
      .sub-title {
        color: $text;
        padding: 0 8px;
        margin: 20px 0;
        border-left: 4px solid $primary;
      }
    }

    .phone{
      text-align: center;
      iframe {
        margin: 20px auto;
        border-radius: 20px;
        &::-webkit-scrollbar {
          width: 0;
        }
        border: 10px solid $border;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/popover.vue